export default __webpack_public_path__ + "static/media/positions-tab.bce5b9ad.svg";